<template>
  <graphql-requester
    :gql="$options.GET_SETTINGS"
    v-slot="{ data, loading }"
    @result="onResult"
  >
    <app-loading v-if="loading" />
    <component
      v-else-if="data && !loading"
      :is="`step-multi-${$flowType}`"
      @scroll-to="$emit('scroll-to', $event)"
      @onnextstep="$emit('onnextstep', $event)"
      @ontimesnearby="$emit('ontimesnearby', $event)"
      @onbookerror="$emit('onbookerror', $event)"
      @on:ocr_scan="$emit('on:ocr_scan', $event)"
      @on:submitted="$emit('on:submitted', $event)"
      @on:book_success="$emit('on:book_success', $event)"
    ></component>
    <app-error v-else />
  </graphql-requester>
</template>

<script>
import { GET_SETTINGS } from "@/graphql";
import { StepMultiReverse, StepMultiNormal } from "@/component";
import GraphqlRequester from "@/components/GraphqlRequester";
import AppLoading from "@/components/AppLoading";
import AppError from "@/components/AppError";

export default {
  GET_SETTINGS,
  components: {
    StepMultiReverse,
    StepMultiNormal,
    AppLoading,
    AppError,
    GraphqlRequester,
  },
  data() {
    return {
      settings: null,
    };
  },
  computed: {
    $flowType() {
      return this.$store.getters.flowType;
    },
  },
  methods: {
    onResult(data) {
      if (!data) return;
      this.settings = data?.getScheduleDetails?.settings;

      this.$store.commit("fieldUpdate", {
        key: "settings",
        value: { ...this.settings },
      });
    },
  },
};
</script>
